//export const API_URL = "https://boyermusteriapi.etkiliyazilim.com/api";
export const API_URL = "https://api.boyertekstil.com/api";

export const getToken = () => {
    return localStorage.getItem('accessToken');
  };
   
  export const setToken = (token) => {
    localStorage.setItem('accessToken', token);
  };